var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _vm.data.source === "SYSTEM"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.showLog },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessPurchaseApplyDetail.operationLog")
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(" " + _vm._s(_vm.$t("BusinessPurchaseDetailPage.Basic")) + " ")]
      ),
      _c("div", { staticClass: "bj-row mt20" }, [
        _c(
          "div",
          { staticClass: "bj-col-12" },
          [
            [
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseDetailPage.number"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.code)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseDetailPage.requisi"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.applyCode)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrderList.contract"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.thirdCode)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v("来源"),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.source)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v("出运国家"),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.countryCode)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseDetailPage.type"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.typeMeaning)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseDetailPage.Receiving"))
                  ),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.warehouseName)),
                ]),
              ]),
            ],
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "bj-col-12" },
          [
            [
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseDetailPage.Buyer"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.buyerName)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseDetailPage.Creation"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.creationDate)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseOrderList.table.Generation"))
                  ),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.documentDate)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseDetailPage.Approval"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.auditTime)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessPurchaseDetailPage.Completion"))
                  ),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.finishTime)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseDetailPage.Remarks"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.remark)),
                ]),
              ]),
            ],
          ],
          2
        ),
      ]),
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("BusinessPurchaseDetailPage.info"))),
      ]),
      _c(
        "div",
        { staticClass: "bj-row" },
        [
          _c(
            "el-col",
            { staticStyle: { "padding-top": "10px" }, attrs: { span: 24 } },
            [
              _c("BjStatusTabs", {
                attrs: {
                  "option-list": _vm.TAB_LIST,
                  value: _vm.auditTabsValue,
                },
                on: { handleTabClick: _vm.handleTabClick },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { staticStyle: { padding: "0 20px" }, attrs: { span: 24 } },
            [
              _vm.auditTabsValue === "tab1"
                ? _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("span"),
                      _c("RightToolbar", {
                        on: { showSetting: _vm.toolbarShow },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.auditTabsValue === "tab1" && _vm.tableShow,
                      expression: "auditTabsValue === 'tab1' && tableShow",
                    },
                  ],
                  attrs: {
                    data: _vm.data.goodsList,
                    border: "",
                    script: "",
                    "max-height": "600",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("table.countText"),
                      type: "index",
                      width: "65",
                      fixed: "left",
                      align: "center",
                    },
                  }),
                  _vm.sortableSetting.skuCode
                    ? _c("el-table-column", {
                        attrs: {
                          label: "SKU",
                          prop: "skuCode",
                          fixed: "left",
                          align: "center",
                          width: "133",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.planQty
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Purchase"
                          ),
                          prop: "planQty",
                          align: "center",
                          width: "88",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.cnPurchasePrice
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseApply.cnPurchasePrice"
                          ),
                          prop: "cnPurchasePrice",
                          align: "center",
                          width: "113",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.auPurchasePrice
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseApply.foreignPurchasePrice"
                          ),
                          prop: "auPurchasePrice",
                          align: "center",
                          width: "135",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.price
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Selling"
                          ),
                          prop: "price",
                          align: "center",
                          width: "100",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.linkUrl
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Link"
                          ),
                          prop: "linkUrl",
                          align: "center",
                          width: "162",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "https://" + row.linkUrl,
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v(_vm._s(row.linkUrl))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          12636240
                        ),
                      })
                    : _vm._e(),
                  _vm.sortableSetting.linkMinPrice
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Price"
                          ),
                          prop: "linkMinPrice",
                          align: "center",
                          width: "108",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.expressPrice
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Express"
                          ),
                          prop: "expressPrice",
                          align: "center",
                          width: "110",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.consumptionTax
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Consumption"
                          ),
                          prop: "consumptionTax",
                          align: "center",
                          width: "132",
                        },
                      })
                    : _vm._e(),
                  _vm.data.type !== "COMMON"
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Platform"
                          ),
                          prop: "platformPrice",
                          align: "center",
                          width: "107",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.resendRefundRate
                    ? _c("el-table-column", {
                        attrs: {
                          label: "refund & resend rate",
                          prop: "resendRefundRate",
                          align: "center",
                          width: "149",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("profitMarginFilter")(
                                          row.resendRefundRate
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          701093897
                        ),
                      })
                    : _vm._e(),
                  _vm.sortableSetting.estimatedProfit
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Estimated"
                          ),
                          prop: "estimatedProfit",
                          align: "center",
                          width: "121",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.estimatedProfitRate
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Expected"
                          ),
                          prop: "estimatedProfitRate",
                          align: "center",
                          width: "131",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    " " + _vm._s(row.estimatedProfitRate) + "% "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1376727228
                        ),
                      })
                    : _vm._e(),
                  _vm.sortableSetting.actualProfitRate
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Actual"
                          ),
                          prop: "actualProfitRate",
                          align: "center",
                          width: "106",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("profitMarginFilter")(
                                          row.actualProfitRate
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3584385844
                        ),
                      })
                    : _vm._e(),
                  _vm.sortableSetting.purchaseRiskLevel
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.risk"
                          ),
                          prop: "purchaseRiskLevel",
                          align: "center",
                          width: "117",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  row.purchaseRiskLevel
                                    ? _c("div", [
                                        row.purchaseRiskLevel === "1"
                                          ? _c("span", {
                                              staticClass: "dot red_dto",
                                            })
                                          : row.purchaseRiskLevel === "2"
                                          ? _c("span", {
                                              staticClass: "dot yellow",
                                            })
                                          : _c("span", {
                                              staticClass: "dot green",
                                            }),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          246845808
                        ),
                      })
                    : _vm._e(),
                  _vm.sortableSetting.barCode
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Barcode"
                          ),
                          prop: "barCode",
                          align: "center",
                          width: "118",
                        },
                      })
                    : _vm._e(),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseDetailPage.table.cartonBoxBarcode"
                      ),
                      prop: "cartonBoxBarcode",
                      align: "center",
                      width: "160",
                    },
                  }),
                  _vm.sortableSetting.brandName
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.brand"
                          ),
                          prop: "brandName",
                          align: "center",
                          width: "113",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.categoryName
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Product1"
                          ),
                          prop: "categoryName",
                          align: "center",
                          width: "143",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.skuName
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Description"
                          ),
                          prop: "skuName",
                          align: "center",
                          width: "146",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.length
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.length"
                          ),
                          prop: "length",
                          align: "center",
                          width: "118",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.width
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.width"
                          ),
                          prop: "width",
                          align: "center",
                          width: "113",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.height
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.high"
                          ),
                          prop: "height",
                          align: "center",
                          width: "117",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.volume
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Volume"
                          ),
                          prop: "volume",
                          align: "center",
                          width: "133",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        isNaN(
                                          (row.width *
                                            row.height *
                                            row.length) /
                                            1000000
                                        )
                                          ? ""
                                          : (row.width *
                                              row.height *
                                              row.length) /
                                              1000000
                                      ) +
                                      " m³ "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3062006203
                        ),
                      })
                    : _vm._e(),
                  _vm.sortableSetting.weight
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Weight"
                          ),
                          prop: "weight",
                          align: "center",
                          width: "118",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.cartonLength
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.boxLength"
                          ),
                          prop: "cartonLength",
                          align: "center",
                          width: "101",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    " " + _vm._s(row.cartonLength) + " cm "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2743676360
                        ),
                      })
                    : _vm._e(),
                  _vm.sortableSetting.cartonWidth
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.boxWidth"
                          ),
                          prop: "cartonWidth",
                          align: "center",
                          width: "92",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    " " + _vm._s(row.cartonWidth) + " cm "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1891811634
                        ),
                      })
                    : _vm._e(),
                  _vm.sortableSetting.cartonHeight
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.boxheight"
                          ),
                          prop: "cartonHeight",
                          align: "center",
                          width: "91",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    " " + _vm._s(row.cartonHeight) + " cm "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          161951307
                        ),
                      })
                    : _vm._e(),
                  _vm.sortableSetting.cartonVolume
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.boxVolume"
                          ),
                          prop: "cartonVolume",
                          align: "center",
                          width: "104",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        isNaN(
                                          (row.cartonLength *
                                            row.cartonWidth *
                                            row.cartonHeight) /
                                            1000000
                                        )
                                          ? ""
                                          : (row.cartonLength *
                                              row.cartonWidth *
                                              row.cartonHeight) /
                                              1000000
                                      ) +
                                      " m³ "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          999723803
                        ),
                      })
                    : _vm._e(),
                  _vm.sortableSetting.cartonWeight
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.boxWeight"
                          ),
                          prop: "cartonWeight",
                          align: "center",
                          width: "93",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    " " + _vm._s(row.cartonWeight) + " kg "
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3295479382
                        ),
                      })
                    : _vm._e(),
                  _vm.sortableSetting.qty
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("BusinessPurchaseDetailPage.table.per"),
                          prop: "qty",
                          align: "center",
                          width: "106",
                        },
                      })
                    : _vm._e(),
                  _vm.sortableSetting.createdName
                    ? _c("el-table-column", {
                        attrs: {
                          label: _vm.$t(
                            "BusinessPurchaseDetailPage.table.Buyer"
                          ),
                          prop: "createdName",
                          align: "center",
                          width: "133",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _vm.auditTabsValue === "tab1"
                ? _c(
                    "div",
                    { staticClass: "mt20 mb20 flex flex-spacebetween" },
                    [
                      _c("span"),
                      _c(
                        "div",
                        {
                          staticClass: "font16",
                          staticStyle: { color: "#3d3d3d" },
                        },
                        [
                          _c("span", { staticClass: "mr20" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("BusinessPurchaseDetailPage.plantQtySum")
                              ) + "："
                            ),
                            _c("span", { staticClass: "font18" }, [
                              _vm._v(_vm._s(_vm.planQtyTotal || 0)),
                            ]),
                          ]),
                          _c("span", { staticClass: "mr20" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessPurchaseDetailPage.productVolume"
                                )
                              ) + "："
                            ),
                            _c("span", { staticClass: "font18" }, [
                              _vm._v(_vm._s(_vm.volumeTotal) + " m³"),
                            ]),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "BusinessPurchaseDetailPage.cartonWeight"
                                )
                              ) + "："
                            ),
                            _c("span", { staticClass: "font18" }, [
                              _vm._v(_vm._s(_vm.weightTotal) + " kg"),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.auditTabsValue === "tab2",
                      expression: "auditTabsValue === 'tab2'",
                    },
                  ],
                  attrs: {
                    data: _vm.data.goodsLinkList,
                    border: "",
                    script: "",
                    "max-height": "600",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("table.countText"),
                      type: "index",
                      width: "65",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.contractNo"),
                      prop: "contractNo",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "SKU", prop: "skuCode", align: "center" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.planQty"),
                      prop: "planQty",
                      align: "center",
                      width: "145",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseForecast.schedulingQty"),
                      prop: "schedulingQty",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseForecast.shippingQty"),
                      prop: "shippingQty",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseForecast.shipmentQty"),
                      prop: "shipmentQty",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("ChannelManagement.Header.currency"),
                      prop: "currency",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.table.UnitPrice"
                      ),
                      prop: "unitPrice",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t(
                        "BusinessPurchaseComponentsPur.table.GrossAmount"
                      ),
                      prop: "totalPrice",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.signDate"),
                      prop: "signDate",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("BusinessPurchaseDetailPage.execStatus"),
                      prop: "execStatus",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    row["execStatus"] === "1"
                                      ? "info"
                                      : "success",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      _vm.EXEC_STATUS_LIST.bjGet(
                                        row["execStatus"]
                                      )
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("BusinessPurchaseDetailPage.Associated"))),
      ]),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.data.associatedList,
            border: "",
            script: "",
            "max-height": "600",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("table.countText"),
              type: "index",
              width: "65",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("BusinessPurchaseDetailPage.dataForm.type"),
              prop: "typeMeaning",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("BusinessPurchaseDetailPage.dataForm.number"),
              prop: "associatedCode",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("BusinessPurchaseDetailPage.dataForm.status"),
              prop: "associatedStatusMeaning",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("BusinessPurchaseDetailPage.dataForm.time"),
              prop: "creationDate",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("BusinessPurchaseDetailPage.dataForm.by"),
              prop: "createdName",
              align: "center",
            },
          }),
        ],
        1
      ),
      _c("ElementTableSortable", {
        ref: "ElementTableSortable",
        attrs: {
          "page-type": _vm.sortableSettingPage,
          "sortable-setting": _vm.sortableSetting,
        },
        on: { settingTableTitle: _vm.settingTableTitle },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }